
import { createMuiTheme } from "@material-ui/core";
const fonts = [
    "Segoe UI Regular",
    "Helvetica Neue",
    "Source Sans Pro",
    "sans-serif"
].join(",");
const headFonts = [
    "Helvetica Neue",
    "Source Sans Pro",
    "sans-serif"
].join(",");

const theme = createMuiTheme({
    typography: {
        fontFamily: fonts,
        "subtitle1": {
            fontSize: 18,
            fontFamily: fonts
        },
        "subtitle2": {
            fontSize: 16,
            fontFamily: fonts
        },
        "body1": {
            fontSize: 15
        },
        "body2": {
            fontSize: 14
        },
        "h1": { fontFamily: headFonts },
        "h2": { fontFamily: headFonts },
        "h3": { fontFamily: headFonts },
        "h4": { fontFamily: headFonts },
        "h5": { fontFamily: headFonts },
        "h6": { fontFamily: headFonts },
        //"caption": { fontFamily: headFonts }
    },
    palette: {
        primary: {
            main: "#96af23",
            dark: "#009641"
        },
        custom: {
            white: "#ffffff",
            black: "#000",
            gray: "#e6e6e6",
            appleMuted: "#009641",
            appleBright: "#96af23",
            darkGray: "#333333"
        }
    },
    shape: {
        borderRadius: 0
    }
});

export default theme;
